import { ReactComponent as CheckCircleOutlined } from '../../../../assets/icons/check-circle-outlined.svg';

export { CheckCircleOutlined };
